// FB 17118
import { useContext, useState, useEffect } from 'react';
import _ from 'lodash';
//import { renderContentFromMetadata } from '@jutro/uiconfig'
import { MetadataContent } from '@jutro/uiconfig';
import { withRouter } from 'react-router-dom';
import { withAuthenticationContext } from 'gw-digital-auth-react';
import { TranslatorContext } from '@jutro/locale';
import styles from './ManageRIUsers.module.scss';
import metadata from './ManageRIUsers.metadata.json5';
import messages from './ManageRIUsers.messages';
import { RIUserList, RIUserEdit } from 'gw-capability-ri-policy-admin-react';

const USER_LIST = 'userList', ADD_USER = 'addUser', EDIT_USER = 'editUser';
    
function ManageRIUsers() {
    const translator = useContext(TranslatorContext);

    const [currentView, setCurrentView] = useState(USER_LIST);
	const [pageMessage, setPageMessage] = useState();
	const [isLoading, setLoadingState] = useState(false);
    const [isReloading, setReloading] = useState(false);
    const [todo, setTodo] = useState('');
    const [selectedUser, setSelectedUser] = useState({});
    const [user, setUser] = useState({});
    const [riUserList, setRIUserList] = useState([]);    
    const [errorText, setErrorText] = useState();
 
    useEffect(() => {
        if(!_.isUndefined(pageMessage)){
            setReloading(true);
        }else{+
            setReloading(false);
        }
    },[pageMessage]);

    const initUserLlist = (userList) => {
        setRIUserList(userList);
    };

    const setMessage = (messageId) => {       
        setPageMessage(messageId);    
    };

    const gotoAddNewUser = () => {
        setPageMessage();
        setErrorText();
        setTodo(ADD_USER);
        setCurrentView(ADD_USER)
    };

    const gotoEditUser = (user) => {
        setPageMessage();
        setErrorText();
        setTodo(EDIT_USER);
        setSelectedUser(user);
        setCurrentView(EDIT_USER);
    };    
    
    const comeBack = () => {
        setCurrentView(USER_LIST)
    };
    
    const overrides = {
		formLoader: {
            loaded: !isLoading
        },  
		pageMessage: {
            visible: !_.isUndefined(pageMessage) && !isLoading || !_.isUndefined(errorText),
            message: !_.isUndefined(pageMessage) ? `${user.userId} ${translator(messages[pageMessage])}` : errorText,
            type: !_.isUndefined(pageMessage) ? 'success' : 'error'
        },
        riUserListing: {
            visible: currentView === USER_LIST && !isLoading,
            method: [comeBack,setMessage,setUser,initUserLlist,gotoAddNewUser,gotoEditUser,setErrorText],
            isReloading: isReloading
        },
        riUserEditing: {
            visible: currentView !== USER_LIST && !isLoading,            
            method: [comeBack,setMessage,setUser,setLoadingState,setErrorText],
            riUserListData: riUserList,
            todo: todo, 
            selectedUser: selectedUser
        }
    };

    let resolvers = {
        resolveClassNameMap: styles, 
        resolveCallbackMap: {

        },
        resolveComponentMap: {
            ri_UserListComponent: RIUserList,
            ri_UserEditComponent: RIUserEdit
        }
    };

    //return renderContentFromMetadata(metadata.pageContent, overrides, resolvers);
    return (
        <MetadataContent
            uiProps={metadata.pageContent}
            overrideProps={overrides}
            {...resolvers}
        />
    );

}

export default withRouter(withAuthenticationContext(ManageRIUsers));
